import React from "react";
import classNames from "classnames";
import { push } from "connected-react-router";
import { connect } from "react-redux";
import { gameLogo } from "../../../utils/index";
import { setGameFilter, setLeagueFilter } from "../../../actions/eventsActions";

class MenuItem extends React.Component {
  render() {
    const { logo, title, count, leagues = [], active, activeLeague, onGameChange, onLeagueChange } = this.props;

    return (
      <div className="esports-menu__item">
        <div className={ classNames("right-sidebar__item", { active }) } onClick={ onGameChange.bind(null, title) }>
          <div className="esports-menu__logo">
            <img src={ logo }/>
          </div>
          <span className="esports-menu__title">
            { title }
          </span>
          <span className="esports-menu__count">
            { count }
          </span>
          <div className="esports-menu__toggler">
            <span/><span/>
          </div>
        </div>
        <div className="esports-menu__leagues">
          { Object.keys(leagues).map(leagueName =>
            <div
              className={ classNames("esports-menu__league", { active: leagueName === activeLeague }) }
              onClick={ onLeagueChange.bind(null, leagueName) }
              key={ leagueName }
            >
              <span className="esports-menu__league-title">
                { leagueName }
                <span className="esports-menu__league-count">{ leagues[leagueName].events_count }</span>
              </span>
            </div>
          ) }
        </div>
      </div>
    );
  }
}

class ESportsMenu extends React.Component {
  toggleGame = (game) => {
    this.handleLocation();
    if (this.props.activeGame === game) game = false;
    this.props.setGameFilter(game);
  };

  toggleLeague = (league) => {
    this.handleLocation();
    if (this.props.activeLeague === league) league = false;
    this.props.setLeagueFilter(league);
  };

  handleLocation = () => {
    if (this.props.route !== "/espotrs") {
      this.props.push("/esports");
    }
  };

  render() {
    const { menu, activeLeague, activeGame } = this.props;

    return (
      <div className="esports-menu">
        { Object.keys(menu).map(gameName =>
          <MenuItem
            logo={ gameLogo(gameName) }
            title={ gameName }
            leagues={ menu[gameName].leagues }
            count={ menu[gameName].events_count }
            onGameChange={ this.toggleGame }
            onLeagueChange={ this.toggleLeague }
            active={ gameName === activeGame } activeLeague={ activeLeague }
            key={ gameName }
          />
        ) }
      </div>
    );
  }
}


export default connect(state => {
  return {
    menu: state.events.menu[state.events.eventsType] || {},
    activeGame: state.events.filters.game,
    activeLeague: state.events.filters.league,
    route: state.router.location.pathname
  };
}, {
  setGameFilter, setLeagueFilter, push
})(ESportsMenu);


// WEBPACK FOOTER //
// ./app/components/EsportsGame/ESportsMenu/ESportsMenu.jsx